<template>
  <div class="plane-order-list" :class="{ isiOSX: isiOSX }">
    <van-nav-bar title="机票订单" left-arrow @click-left="goBack" />
    <p class="tab">
      <span @click="tabChecked(0)" :class="{ active: tabs[0] }">全部订单</span>
      <span @click="tabChecked(1)" :class="{ active: tabs[1] }">待支付</span>
    </p>
    <div class="order-content">
      <van-pull-refresh
        v-model="isLoading"
        @refresh="onRefresh"
        v-if="hasOrder"
      >
        <van-list
          class="allList"
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <van-cell v-for="(item, index) in list" :key="index">
            <div class="oilList" :style="liststyle">
              <p class="company">
                <img
                  :src="item.list_extend.order_flight_info.air_comImage_url"
                />
                <span class="name"
                  >{{ item.list_extend.order_flight_info.company_name }}
                  {{ item.list_extend.order_flight_info.flight_no }}</span
                >
                {{
                  item.list_extend.order_flight_info.craft_type_name ||
                  item.list_extend.order_flight_info.craft_type
                }}
                <span v-if="item.list_extend.order_flight_info.plane_model"
                  >(<span
                    v-if="item.list_extend.order_flight_info.plane_model == 1"
                    >大</span
                  ><span
                    v-if="item.list_extend.order_flight_info.plane_model == 2"
                    >中</span
                  ><span
                    v-if="item.list_extend.order_flight_info.plane_model == 3"
                    >小</span
                  ><span
                    v-if="item.list_extend.order_flight_info.plane_model == 0"
                    >其他</span
                  >)</span
                >
                <span v-else>(其他)</span>
                <span class="time">{{
                  item.list_extend.order_flight_info.depart_date
                }}</span>
                <span class="right">
                  <span v-show="item.list_extend.status == -3">已退票</span>
                  <span
                    v-show="
                      item.list_extend.status == -1 ||
                      item.list_extend.status == -2
                    "
                    >已取消</span
                  >
                  <span v-show="item.list_extend.status == 1">待支付</span>
                  <span
                    v-show="
                      item.list_extend.status == 2 ||
                      item.list_extend.status == 6
                    "
                    >确认中</span
                  >
                  <span v-show="item.list_extend.status == 3">确认失败</span>
                  <span v-show="item.list_extend.status == 4">已出票</span>
                  <span v-show="item.list_extend.status == 5">交易完成</span>
                </span>
              </p>
              <div class="airline" @click="goToSeeDetail(item.ordersn)">
                <p>
                  <span class="edge">
                    <span class="city">{{
                      item.list_extend.order_flight_info.depart_city_name
                    }}</span>
                    <span class="time">{{
                      item.list_extend.order_flight_info.depart_time
                    }}</span>
                    <span class="airport"
                      >{{
                        item.list_extend.order_flight_info.depart_airport_name
                      }}{{
                        item.list_extend.order_flight_info
                          .depart_airport_terminal
                      }}</span
                    >
                  </span>
                  <span class="middle">
                    <span>{{
                      item.list_extend.order_flight_info.flight_time
                    }}</span>
                    <img
                      v-if="
                        item.list_extend.order_flight_info.stop_num == 0 ||
                        item.list_extend.order_flight_info.stop_info.length == 0
                      "
                      src="../../assets/plane/aircraft.png"
                    />
                    <img
                      v-if="
                        item.list_extend.order_flight_info.stop_num != 0 &&
                        item.list_extend.order_flight_info.stop_info.length !=
                          0 &&
                        !item.list_extend.order_flight_info.stop_info[0]
                          .flight_no1
                      "
                      src="../../assets/plane/stop.png"
                    />
                    <img
                      v-if="
                        item.list_extend.order_flight_info.stop_num != 0 &&
                        item.list_extend.order_flight_info.stop_info.length !=
                          0 &&
                        item.list_extend.order_flight_info.stop_info[0]
                          .flight_no1
                      "
                      src="../../assets/plane/stop_long.png"
                    />
                  </span>
                  <span class="edge">
                    <span class="city">{{
                      item.list_extend.order_flight_info.arrive_city_name
                    }}</span>
                    <span class="time">{{
                      item.list_extend.order_flight_info.arrive_time
                    }}</span>
                    <span class="airport"
                      >{{
                        item.list_extend.order_flight_info.arrive_airport_name
                      }}{{
                        item.list_extend.order_flight_info
                          .arrive_airport_terminal
                      }}</span
                    >
                  </span>
                </p>
              </div>
              <p class="editor">
                <span class="left">￥{{ item.list_extend.pay_money }}</span>
                <!-- <span class="reback left">返</span> -->
                <span
                  class="credit right"
                  @click="settlement(item.ordersn)"
                  v-show="
                    item.list_extend.status == 4 &&
                    item.list_extend.giving_credits_status == 1 &&
                    item.list_extend.order_flight_info.diff <= 0
                  "
                  >领取积分</span
                >
                <span
                  class="delect right"
                  @click="showPopup(item.ordersn)"
                  v-show="
                    item.list_extend.status == 5 ||
                    item.list_extend.status == -1 ||
                    item.list_extend.status == -2
                  "
                  >删除订单</span
                >
              </p>
            </div>
          </van-cell>
        </van-list>
      </van-pull-refresh>
      <van-row class="empty" v-if="!hasOrder">
        <van-col class="emptyMsg" span="24">
          <img src="../../assets/plane/noOrder.png" />
          <p class="tip1">暂无相关订单</p>
          <p class="btn">
            <span @click="goBack">返回</span>
          </p>
        </van-col>
      </van-row>
    </div>
    <van-popup v-model="show">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt="" />
        <p class="title">温馨提示</p>
        <p class="tips">亲，您真的要删除该订单吗？</p>
        <span class="left" @click="cancle()">取消</span>
        <span class="right" @click="confirm()">确认</span>
      </div>
    </van-popup>
    <van-popup class="tipMSG" v-model="showTip">
      <div class="box">
        <img src="../../assets/common/BG@2x.png" alt="" />
        <p class="title">您已提交申请，请勿重复操作</p>
        <p class="tips">积分预计两小时内到账，详情请咨询客服</p>
        <span class="right_big" @click="tipHide()">确定</span>
      </div>
    </van-popup>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [],
      loading: false,
      finished: false,
      isLoading: false,
      page: 1,
      pageSize: 10,
      allList: 11, //默认比第一页数据多1
      liststyle: {
        width: document.body.clientWidth - 40 + "px",
      },
      hasOrder: false,
      status: 0,
      tabs: [1, 0],
      show: false,
      delectOrderSn: 0,
      isiOSX: false,
      showTip: false,
    };
  },
  created() {
    this.$api.setToken(this.$route.query.token);
    this.getInfo();
    this.isiOSX = this.isIphoneX();
  },
  methods: {
    onLoad() {
      // 异步更新数据
      setTimeout(() => {
        this.page++;
        this.getInfo();

        // 加载状态结束
        this.isLoading = false;
      }, 500);
    },
    onRefresh() {
      this.page = 1;
      this.finished = false;
      this.list = [];
      this.getInfo();
    },
    goBack() {
      if (this.$route.query.from) {
        this.params("", "", "goBack");
      } else if (this.$route.query.back == 4) {
        this.$router.go(-4);
      } else {
        this.$router.go(-1);
      }
    },
    goToSeeDetail(ordersn) {
      this.$router.push({
        path: "/order/detail",
        query: {
          ordersn: ordersn,
        },
      });
    },
    tabChecked(a1) {
      var b0 = this.tabs[0];
      var b1 = this.tabs[1];
      this.tabs = [0, 0];
      this.tabs[a1] = 1;
      if (a1 == 0) {
        this.status = 0;
        this.list = [];
        this.page = 1;
        this.getInfo();
      } else if (a1 == 1) {
        this.status = 10;
        this.list = [];
        this.page = 1;
        this.getInfo();
      }
    },
    // 获取订单列表
    getInfo() {
      this.$api
        .post("/order/member/order/list", {
          status: this.status,
          page: this.page,
          type: "air",
        })
        .then((res) => {
          this.allList = res.total;
          this.hasOrder = !!res.total;
          if (res.list.length > 0) {
            for (let i in res.list) {
              var depart_date =
                res.list[i].list_extend.order_flight_info.depart_date;
              var flight_time =
                res.list[i].list_extend.order_flight_info.flight_time;
              var hh = Math.floor(flight_time / 60 / 60);
              var mm = (flight_time - hh * 60 * 60) / 60;
              res.list[i].list_extend.order_flight_info.depart_date =
                depart_date.substr(5, 5);
              res.list[i].list_extend.order_flight_info.flight_time =
                hh + "小时" + mm + "分钟";
              //是否可领取积分
              var current = Math.floor(new Date().getTime() / 1000);
              var arrival_time =
                res.list[i].list_extend.order_flight_info.arrive_date +
                " " +
                res.list[i].list_extend.order_flight_info.arrive_time +
                ":00";
              res.list[i].list_extend.order_flight_info.diff =
                this.date2timestamp(arrival_time) - current + 2 * 60 * 60;

              this.list.push(res.list[i]);
            }
          }
          this.loading = false;
          if (this.list.length >= this.allList) {
            // 数据全部加载完成
            this.finished = true;
          }
          if (this.isLoading) {
            this.$toast("刷新成功");
            this.isLoading = false;
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    showPopup(orderSn) {
      this.show = true;
      this.delectOrderSn = orderSn;
    },
    cancle() {
      this.show = false;
    },
    tipHide() {
      this.showTip = false;
    },
    confirm() {
      this.show = false;
      this.$api
        .post("/order/member/order/delete", { ordersn: this.delectOrderSn })
        .then((res) => {
          var length = this.page;
          this.list = [];
          this.page = 0;
          for (var j = 0; j < length; j++) {
            this.page = j + 1;
            this.getInfo();
          }
        })
        .catch((err) => {
          let keys = Object.keys(err);
          let key = keys[0];
          let message = err.message || err[key][0];
          //	      this.$toast(message);
          if (message.slice(0, 10) == "timeout of") {
            this.$toast("网络不给力，请稍候重试");
          } else {
            this.$toast(message);
          }
          return;
        });
    },
    //领取积分
    settlement(ordersn) {
      console.log(ordersn);
      this.$api
        .post("/order/member/order/settle", { ordersn: ordersn })
        .then((res) => {
          this.$toast("领取成功");
          var length = this.page;
          this.list = [];
          this.page = 0;
          for (var j = 0; j < length; j++) {
            this.page = j + 1;
            this.getInfo();
          }
        })
        .catch((err) => {
          if (err.code == 99998) {
            this.showTip = true;
          }
        });
    },
  },
};
</script>

<style lang="less">
.plane {
  &-order-list {
    background: #f2f2f2;
    height: 100%;
    .van-nav-bar {
      background: #f2f2f2;
      padding-top: 24px;
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      .van-nav-bar__title {
        font-size: 18px;
        color: #333;
      }
      .van-icon-arrow-left:before {
        display: none;
      }
      .van-nav-bar__left {
        left: 11px;
        .van-icon {
          width: 17px;
          height: 15px;
          display: inline-block;
          background: url(../../assets/plane/reBack.png) no-repeat center center;
          background-size: 100% 100%;
        }
      }
    }
    .tab {
      height: 45px;
      line-height: 45px;
      position: fixed;
      top: 69px;
      left: 0;
      width: 100%;
      background: #fff;
      z-index: 1;
      span {
        color: #333;
        width: 50%;
        height: 45px;
        display: inline-block;
        text-align: center;
        font-size: 14px;
      }
      .active {
        color: #e6212f;
      }
    }
    .van-hairline--bottom::after {
      border: none;
    }
    .order-content {
      height: 100%;
      overflow-y: scroll;
      -webkit-overflow-scrolling: touch;
      .van-pull-refresh {
        padding-top: 116px;
        .allList {
          padding: 4px 11px 0;
          background: #f2f2f2;
          .van-cell {
            background: #fff;
            border-radius: 10px;
            margin-bottom: 7px;
            box-shadow: #e3e3e3 2px 0 4px;
            padding: 0 0 0 10px;
            position: relative;
            .oilList {
              .company {
                color: #666;
                font-size: 13px;
                height: 31px;
                line-height: 36px;
                overflow: hidden;
                border-bottom: solid 1px #f2f2f2;
                img {
                  width: 14px;
                  float: left;
                  margin-top: 9px;
                }
                .name {
                  color: #333;
                  padding: 0 15px 0 7px;
                }
                .time {
                  margin-left: 15px;
                  font-weight: bold;
                }
                .right {
                  float: right;
                  color: #e6212f;
                  font-size: 11px;
                }
              }
              @media screen and (max-width: 320px) {
                .company {
                  font-size: 9px !important;
                  img {
                    width: 12px;
                    float: left;
                    margin-top: 12px;
                  }
                  .name {
                    padding: 0 5px 0 4px;
                  }
                  .time {
                    margin-left: 8px;
                  }
                }
              }
              .airline {
                text-align: center;
                padding: 0 8px;
                p {
                  display: flex;
                  justify-content: space-between;
                  align-items: center;
                }
                span {
                  display: inline;
                  text-align: center;
                  color: #666;
                  font-size: 13px;
                }
                .edge {
                  text-align: center;
                  display: inline-block;
                  span {
                    display: inline-block;
                  }
                  .city {
                    color: #333;
                    font-size: 17px;
                    height: 34px;
                    line-height: 34px;
                    margin-top: 5px;
                    display: block;
                  }
                  .time {
                    height: 18px;
                    line-height: 18px;
                    display: block;
                  }
                  .airport {
                    height: 19px;
                    line-height: 19px;
                    margin-bottom: 14px;
                    display: block;
                  }
                }
                .middle {
                  width: 97px;
                  display: inline-block;
                  vertical-align: bottom;
                  padding-bottom: 18px;
                  span {
                    width: 97px;
                    height: 18px;
                    line-height: 19px;
                    border-radius: 9px;
                    color: #fff;
                    font-size: 13px;
                    background: #feab7a;
                    text-align: center;
                    display: inline-block;
                    margin-bottom: 16px;
                  }
                  img {
                    width: 97px;
                    display: block;
                  }
                }
                @media screen and (max-width: 320px) {
                  .middle {
                    padding: 0 14px 17px 14px;
                  }
                }
              }
              .editor {
                height: 45px;
                line-height: 45px;
                border-top: solid 1px #f2f2f2;
                color: #e6212f;
                font-size: 17px;
                .left {
                  float: left;
                }
                .reback {
                  color: #333;
                  font-size: 11px;
                  width: 14px;
                  height: 14px;
                  line-height: 14px;
                  border-radius: 3px;
                  background: #ffc663;
                  margin-left: 7px;
                  text-align: center;
                  margin-top: 16px;
                }
                .right {
                  float: right;
                  font-size: 12px;
                  text-align: center;
                  width: 69px;
                  height: 24px;
                  line-height: 24px;
                  border-radius: 12px;
                  margin-top: 11px;
                }
                .delect {
                  color: #333;
                  border: solid 1px #999;
                  margin-right: 10px;
                }
                .credit {
                  color: #e6212f;
                  border: solid 1px rgba(230, 33, 47, 0.4);
                }
              }
            }
          }
        }
      }
    }
    .empty {
      padding-top: 202px;
      .emptyMsg {
        padding: 0 93px;
        text-align: center;
        img {
          width: 100%;
          display: block;
        }
        .tip1 {
          color: #b9b9b9;
          font-size: 15px;
          height: 51px;
          line-height: 51px;
          margin-bottom: 12px;
        }
        .btn {
          text-align: center;
          span {
            width: 110px;
            height: 32px;
            line-height: 32px;
            color: #ff6059;
            display: inline-block;
            border: solid 1px rgba(255, 96, 89, 0.4);
            border-radius: 16px;
            box-shadow: rgba(255, 96, 89, 0.1) 3px 0 6px;
          }
        }
      }
    }
    .editorList {
      margin-left: -65px;
    }
    .van-popup--center {
      width: 70%;
      border-radius: 10px;
      .box {
        img {
          display: block;
          width: 100%;
        }
        .title {
          color: #333;
          font-size: 15px;
          font-weight: 600;
          line-height: 47px;
          margin-top: 8px;
          text-align: center;
        }
        .tips {
          color: #333;
          font-size: 13px;
          line-height: 18px;
          text-align: center;
          margin-bottom: 30px;
        }
        span {
          float: left;
          width: 50%;
          border-top: solid 1px #f2f2f2;
          line-height: 43px;
          color: #999;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
        .right {
          color: #e6212f;
          width: calc(50% - 1px);
          border-left: solid 1px #f2f2f2;
        }
      }
    }
    .tipMSG {
      width: 70%;
      border-radius: 10px;
      .box {
        .right_big {
          width: 100%;
          line-height: 43px;
          color: #e6212f;
          font-size: 14px;
          text-align: center;
          display: inline-block;
        }
      }
    }
  }
}
.isiOSX {
  .van-nav-bar {
    padding-top: 44px;
  }
  .tab {
    top: 89px;
  }
  .order-content {
    .van-pull-refresh {
      padding-top: 136px;
    }
  }
}
</style>
